import React from 'react';
import { useLoading } from '../../hooks/useLoading';
import { Wrapper, Spin } from './styles';
const Loading = ({ loading }) => {
    return (
        <>
            {loading ? (
                <Wrapper>
                    <Spin />
                </Wrapper>
            ) : ''}
        </>
    )
}

export default Loading
